import { Zone } from "../Model/Zone";
export class ZonesService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async getZones() {
        const response = await this.apiService.get('zones');
        if (!response.ok) {
            throw new Error(`Error al obtener las zonas.`);
        }
        const content = await response.json();
        return content.map(zone => new Zone(zone.id, zone.name, zone.shape, zone.schedule, zone.time));
    }
    async getZone(zoneId) {
        const response = await this.apiService.get('zone/' + zoneId);
        if (!response.ok) {
            throw new Error(`Error al obtener la zona.`);
        }
        const content = await response.json();
        return new Zone(content.id, content.name, content.shape, content.schedule, content.time);
    }
}
